var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 28 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6F8F8",
    d: "M-38-271h375V829H-38z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28 -157)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 353,
    height: 350,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#F6F8F7",
    rx: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 12.5,
    stroke: "#000000",
    strokeWidth: 1.8,
    rx: 12.552,
    ry: 12.5,
    transform: "translate(29 158)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.44,
    d: "M36.873 167.291h10.99c.078 0 .17.159.216.216.062.057.077.2.046.272l-1.69 5.244c-.093.344-.416.543-.799.543h-6.624c-.385 0-.722-.17-.799-.514 0 0-1.431-5.31-1.69-6.34-.261-1.033-.525-1.461-1.609-1.461"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M41.293 176.048c0 .63-.548 1.142-1.225 1.142s-1.224-.511-1.224-1.142c0-.631.547-1.143 1.224-1.143.677 0 1.225.512 1.225 1.143m3.962 0c0 .63-.548 1.142-1.225 1.142s-1.225-.511-1.225-1.142c0-.631.548-1.143 1.225-1.143s1.225.512 1.225 1.143"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCart);
export default __webpack_public_path__ + "static/media/green-cart.7c33ab82c13a08807b4d3e574043d14d.svg";
export { ForwardRef as ReactComponent };